import { render, staticRenderFns } from "./form-header.vue?vue&type=template&id=29d8c2b6&"
import script from "./form-header.vue?vue&type=script&lang=ts&"
export * from "./form-header.vue?vue&type=script&lang=ts&"
import style0 from "./form-header.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports